
import { API } from "../../config/api";
import { GET, POST } from "../../utils/apicalls";
import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Select,
  Space,
  Spin,
  Table,

} from "antd";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function HrInternshipIndex() {
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState(null);

  const timeSlots = ["online-10:00 AM - 12:00 PM", "online-2:00 PM - 4:00 PM", "online-8:00 PM - 10:00 PM"];

  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const navigate = useNavigate();

  const fetchinterndetails = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 5,
      };
      const url = API.LIST_INTERNSHIP_STUDENTS_DETAILS;
      const response: any = await POST(url, obj);
      setData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchinterndetails(page, pageSize);
  }, [page, pageSize]);

  const submitHandler = async (values: any) => {
    try {
      let obj = {
        internName: values.internName,
        internAddress: values.internAddress,
        internEmail: values.internEmail,
        phone: values.phone,
        mode: values.mode,
        email: values.email,
        joinDate: values.joinDate,
        PayementAmount: Number(values.PayementAmount),
        internpayment: values.internpayment,
        PayementType: values.PayementType,

      };

      setIsLoading(true);
      const postRequest: any = await POST(API.CREATE_INTERNSHIP_STUDENTS_DETAILS, obj);
      if (postRequest.status) {
        notification.success({
          message: "intern added successfully!",
        });

        form.resetFields();
        fetchinterndetails(page, pageSize);
        //   fetchcontactinformation();
        setIsModalOpen(false); // Close modal
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      render: (_: any, __: any, index: number) => index + 1,
    },
    { title: "internName", dataIndex: "internName" },
    { title: "internAddress", dataIndex: "internAddress" },
    {
      title: "phone",
      dataIndex: "phone",
    },
    { title: "internEmail", dataIndex: "internEmail" },
    { title: "mode", dataIndex: "mode" },

    {
      title: "Join Date",
      dataIndex: "joinDate",
      render: (text: any) => new Date(text).toLocaleDateString(), // Format date as per your requirement
    },

    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space size="middle">
          {/* <Button type="link"  onClick={() => confirmDelete(record.id)}>Delete</Button> */}
          <Button
            type="link"
            onClick={() =>
              navigate(
                `/hr/HrInternshipIndex/updateInternship/${record.id}`
              )
            }
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];
  return (
    <div>
      <div className="banner-container">
        {isLoading ? (
          <Spin />
        ) : (
          <div className="banner-content" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px" }}>
            <h1 className="banner-title">Intern Details</h1>
            <button className="banner-button" onClick={() => setIsModalOpen(true)}>
              Create Intern
            </button>
          </div>
        )}
      </div>

      <div className="w-full px-4">
        <Card className="w-full">
          {isLoading ? (
            <Spin />
          ) : (
            <div className="overflow-x-auto">
              <Table
                columns={columns}
                dataSource={data}
                loading={isLoading}
                pagination={{ pageSize: 5 }}
                scroll={{ x: "max-content" }}
              />
            </div>
          )}
        </Card>
      </div>

      <Modal
        title="Add Contact Information"
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width="90%"
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Form.Item
            name="internName"
            label="internName"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="internAddress"
            label="internAddress"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="internEmail"
            label="internEmail"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="phone"
            label="phone"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item name="mode" label="Mode" rules={[{ required: true, message: "Please select a mode" }]}>
            <Select placeholder="Select mode" onChange={(value) => setMode(value)}>
              <Select.Option value="online">Online</Select.Option>
              <Select.Option value="offline">Offline</Select.Option>
            </Select>
          </Form.Item>

          {mode === "online" && (
            <Form.Item name="mode" label="Time Slot" rules={[{ required: true, message: "Please select a time slot" }]}>
              <Select placeholder="Select a time slot">
                {timeSlots.map((slot) => (
                  <Select.Option key={slot} value={slot}>{slot}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}


          <Form.Item name="joinDate" label="joinDate" rules={[{ required: true }]}>
            <DatePicker />
          </Form.Item>
          <Form.Item name="internpayment" label="internpayment" rules={[{ required: true }]}>
            <DatePicker />
          </Form.Item>
          <Form.Item name="PayementAmount" label="PayementAmount" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="PayementType" label="Payement type" rules={[{ required: true }]}>
            <Select placeholder="Select a Payement type" allowClear>
              <Select.Option value="advance">Advance</Select.Option>
              <Select.Option value="Balance_payement">Balance payement</Select.Option>

            </Select>
          </Form.Item>


          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  )
}

export default HrInternshipIndex
